/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import widgetModule from "@stoneage/Overrides/Widgets/Basic/LinkList";
import { linkListStyles } from "@stoneage/Overrides/Widgets/Basic/LinkList";
import { css } from "styled-components";

linkListStyles.linkWrapper = {
    css: css`
        padding-top: 14px;
        .list-link {
            color: ${getColor("common.ui7")};
            &:hover,
            &:focus {
                color: ${getColor("primary.main")};
            }
            span {
                color: ${getColor("common.white")};
                opacity: 0.5;
                font-weight: 300;
                & :hover {
                    color: ${getColor("common.white")};
                }
            }
        }
    `,
};

export * from "@stoneage/Overrides/Widgets/Basic/LinkList";

export default widgetModule;
